"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAYS_DIALOG_MODE = exports.DaysDialog = void 0;
const core_1 = require("../../../core");
const daysDialog_json_1 = __importDefault(require("./resources/daysDialog.json"));
const DaysDialog_1 = require("./DaysDialog");
exports.DaysDialog = core_1.WithFeatureContext(DaysDialog_1.DaysDialog, daysDialog_json_1.default);
var types_1 = require("./types");
Object.defineProperty(exports, "DAYS_DIALOG_MODE", { enumerable: true, get: function () { return types_1.DAYS_DIALOG_MODE; } });
//# sourceMappingURL=index.js.map